<script lang="ts">
  import Autocomplete from '@smui-extra/autocomplete';
  import Textfield from '@smui/textfield';
  import IconButton from '@smui/icon-button';
  import Tooltip, { Wrapper } from '@smui/tooltip';

  import { useNodeViewContext } from '@prosemirror-adapter/svelte';
  import { refractor } from 'refractor';
  import { onMount } from 'svelte';

  const contentRef = useNodeViewContext('contentRef');
  const setAttrs = useNodeViewContext('setAttrs');
  const node = useNodeViewContext('node');
  const view = useNodeViewContext('view');
  const editable = view.props.editable?.(view.props.state) ?? false;

  const languages: string[] = refractor.listLanguages();

  let lang: string | undefined;
  let language: string = 'text';
  let text: string = '';
  let initialized = false;

  onMount(() => {
    lang = language = $node.attrs.language || 'text';
    initialized = true;
  });

  const onDelete = (e: any) => {
    const ev = e as KeyboardEvent;
    if (ev.key !== 'Backspace') {
      return;
    }

    ev.preventDefault();

    const target = ev.target;

    if (!(target instanceof HTMLInputElement) || target.disabled) {
      return;
    }

    const start = target.selectionStart;
    const end = target.selectionEnd;

    if (!start || !end) {
      return;
    }

    if (start === end) {
      text = text.slice(0, start - 1) + text.slice(start);
      setTimeout(() => {
        target.selectionStart = start - 1;
        target.selectionEnd = start - 1;
      });
      return;
    }

    text = text.slice(0, start) + text.slice(end);
    setTimeout(() => {
      target.selectionStart = start;
      target.selectionEnd = start;
    });
  };

  const handle = (e: CustomEvent<string>) => {
    e.preventDefault();
    lang = text = language = e.detail;
    setAttrs({
      language,
    });
  };

  type $$Props = {};
</script>

<div class="code-block not-prose">
  <div class="controls" contenteditable="false">
    <div class="left">
      <Autocomplete options={languages} bind:value={lang} bind:text on:SMUIAutocomplete:selected={handle}>
        <Textfield bind:value={text} label="言語" disabled={!editable} on:keydown={onDelete} />
      </Autocomplete>
    </div>
    <div class="right">
      <Wrapper>
        <IconButton
          class="material-symbols-outlined"
          type="button"
          on:click={(e) => {
            e.stopPropagation();
            navigator.clipboard.writeText($node.textContent);
          }}
        >
          file_copy
        </IconButton>
        <Tooltip>コードをコピー</Tooltip>
      </Wrapper>
    </div>
  </div>
  <pre data-language={language ?? 'text'}><code use:contentRef /></pre>
</div>

<style lang="scss">
  .code-block {
    border: 1px solid;
    border-radius: 5px;
    padding: 0.5rem;
  }

  .controls {
    display: flex;
    height: 0;
    margin-bottom: 2.5rem;
    margin-top: -0.5rem;

    :global(.smui-autocomplete__menu.mdc-menu.mdc-menu-surface) {
      margin-top: -1.2rem;
    }
  }

  pre {
    margin: 0;

    :global(code) {
      width: 100%;
    }
  }
</style>
